import { API_BASE_URL, getAuthHeaders } from "../API/Api";

export const extractApiList = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
  return [];
};

export const getPaginationInfo = (responseData) => {
  const paginated = responseData?.data;

  if (paginated && typeof paginated === "object" && !Array.isArray(paginated)) {
    return {
      items: Array.isArray(paginated.data) ? paginated.data : [],
      currentPage: paginated.current_page ?? paginated.meta?.current_page ?? 1,
      lastPage: paginated.last_page ?? paginated.meta?.last_page ?? 1,
    };
  }

  const meta = responseData?.meta;
  return {
    items: extractApiList(responseData),
    currentPage: meta?.current_page ?? 1,
    lastPage: meta?.last_page ?? 1,
  };
};

export const fetchAllBrands = async () => {
  const allBrands = [];
  let page = 1;
  let lastPage = 1;

  do {
    const res = await fetch(
      `${API_BASE_URL}/admin/brands?per_page=3000&page=${page}`,
      {
        headers: getAuthHeaders(),
      },
    );

    if (!res.ok) {
      throw new Error(`HTTP error! Status: ${res.status}`);
    }

    const responseData = await res.json();
    const { items, lastPage: totalPages } = getPaginationInfo(responseData);
    allBrands.push(...items);
    lastPage = totalPages;
    page += 1;
  } while (page <= lastPage);

  return allBrands;
};

export const filterBrandOptions = (options, { inputValue }) => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return options;

  return options.filter(
    (option) =>
      String(option?.name || "")
        .toLowerCase()
        .includes(query) ||
      String(option?.slug || "")
        .toLowerCase()
        .includes(query),
  );
};

export const normalizeBrandRow = (item, index) => ({
  index: index + 1,
  id: item.id,
  name: item.name || "",
  slug: item.slug || "",
  image_url: item.image_url || "",
});
